import Tools from './tools';

export default class Nav {
  constructor() {
    // Nav
    this.WINHEIGHT = window.innerHeight;
    window.addEventListener('resize', () => {
      this.WINHEIGHT = window.innerHeight;
    });

    window.addEventListener('scroll', () => {
      this.stickyNav(window.pageYOffset);
    });

    this.openForm();
    this.menuBurger();
    this.clickAncres();
  }

  stickyNav(top) {
    if (top > this.WINHEIGHT) {
      document.querySelector('nav').classList.add('sticky');
    } else {
      document.querySelector('nav').classList.remove('sticky');
    }
  }

  openForm() {
    const form = document.querySelector('aside.form-contact');
    const btns = document.querySelectorAll('a[href="#openForm"]');
    if (form && btns.length > 0) {
      btns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          form.classList.add('open');
        });
      });

      form.querySelector('.overlay').addEventListener('click', () => {
        form.classList.remove('open');
      });

      form.querySelector('.close').addEventListener('click', () => {
        form.classList.remove('open');
      });
    }
  }

  menuBurger() {
    const burgerBtn = document.querySelector('nav .container .burger-menu');
    if (burgerBtn) {
      burgerBtn.addEventListener('click', () => {
        burgerBtn.classList.toggle('open');
        document.querySelector('nav .container .main-menu').classList.toggle('open');
      });
    }
  }

  clickAncres() {
    const links = document.querySelectorAll('nav .container .main-menu li a');
    if (links.length > 0) {
      links.forEach((link) => {
        if (link.href.includes('#') && window.innerWidth < 1024) {
          link.addEventListener('click', () => {
            document.querySelector('nav .container .burger-menu').click();
          });
        }
      });
    }
  }
}